import { formatMoney } from "../../functions";

export function calculateTotalAmount(form) {
    let totalAmount = 0;

    // store tickets with their prices
    let ticketsPrice = [];
    $("[data-ticket]").each(function () {

        let ticketComponentKey = $(this).attr("data-ticket");
        let ticketExist = ticketsPrice.find((ticket) => ticket.component_key === ticketComponentKey);
        if (!ticketExist) { // cuz radio element gets duplicated, this will add it once
            ticketsPrice.push({
                component_key: ticketComponentKey,
                price_amount: 0,
            });
        }
    })

    // on change get element changed
    form.on("change", (modification) => {
        let changed = modification.changed;
        let visibleTickets =  []

        // if tickets were hidden, add them
        $("[data-ticket]").each(function () {
            let ticketComponentKey = $(this).attr("data-ticket");
            let ticketExist = ticketsPrice.find((ticket) => ticket.component_key === ticketComponentKey);
            if (!ticketExist) { // if doesn't exist, add it
                ticketsPrice.push({
                    component_key: ticketComponentKey,
                    price_amount: 0,
                });

            }

            // Store the visible tickets
            visibleTickets.push(ticketComponentKey)
        })

        // Check if a ticket was visible and got hidden
        // Set their price_amount to 0
        // And reset their value
        ticketsPrice.map(function(ticket) {
            if (!visibleTickets.includes(ticket.component_key)) {
                ticket.price_amount = 0;
                form.getComponent(ticket.component_key).resetValue();
            };
            return ticket;
        })

        if (changed && ticketsPrice.length) {
            totalAmount = 0;
            ticketsPrice.forEach((ticket) => {
                if (changed.component.key == ticket.component_key) {
                    if (changed.value === false || changed.value == '') {//unchecked or deselected an element
                        ticket.price_amount = 0;

                    } else if (changed.component.type == 'checkbox') {
                        if (changed.value === true) {// checked
                            ticket.price_amount =
                                changed.component.value.amount;

                        }

                    } else {
                        // Get ticket prices
                        let prices;
                        if (changed.component.type == 'radio' || changed.component.type == 'selectboxes') {
                            prices = changed.component.values;
                        } else if (changed.component.type == 'select') {
                            prices = changed.component.data.values;
                        }


                        if (changed.component.type == 'selectboxes') {
                            // reset ticket amount
                            ticket.price_amount = 0;

                            // Get selected prices
                            let selectedPricesIds = [];
                            Object.entries(changed.value).forEach((priceElem) => {
                                if (priceElem[1] == true) { // check if selected
                                    selectedPricesIds.push(parseInt(priceElem[0])); // store id
                                }
                            });

                            // Sum the selected prices amount
                            prices.forEach((price) => {
                                if (selectedPricesIds.includes(price.value)) {
                                    ticket.price_amount += price.amount;
                                }
                            });

                        } else { // if select or radio component
                            // Set the selected price amount
                            prices.forEach((price) => {
                                if (price.value == changed.value) {
                                    ticket.price_amount = price.amount;
                                }
                            });
                        }

                    }
                }
            });

            // add prices into totalAmount
            ticketsPrice.map((ticket) => {
                totalAmount = totalAmount + ticket.price_amount;
            });

            // display totalAmount in html element
            $("#totalPayment").html("Total : "+ formatMoney(totalAmount));

        }
    });
}

export function setBackendValidationRules(form, isFieldsRequired = true) {
    let validationRules = {};

    // Preparing backend validation rules
    form.everyComponent((component) => {
        let componentName = component.component.key;

        if (component.getValue() && !component.element.classList.contains("formio-hidden")) {

            let hasRequiredClass = component.element.classList.contains("required");
            validationRules[componentName] = hasRequiredClass && isFieldsRequired
                ? ["required"]
                : ["nullable"];

        }
    });

    return validationRules;
}



/**
 *
 * @param {*} components
 * @param {*} addedComponent
 */
export function assertComponentIsUnique(form, addedComponent) {
    let componentOccurences = 0;
    let index;
    let parentIndex;

    form.form.components.forEach((component, i) => {
        if (component.hasOwnProperty('components') && component.components.length > 0) {
            parentIndex = i
            component.components.forEach((nestedCompo, nestedIndex) => {
                if (nestedCompo.modelId == addedComponent.modelId && addedComponent.modelId != undefined) {
                    componentOccurences++
                    if (componentOccurences > 1) {
                        index = nestedIndex;
                    }
                }
            })
        }

        if (component.modelId == addedComponent.modelId && addedComponent.modelId != undefined) {
            index = i;
            componentOccurences++
        }
    })

    if (parentIndex != undefined && componentOccurences > 1) {
        alert("Ce champ est déjà présent dans le formulaire");
        form.form.components[parentIndex].components.splice(
            index,
            1
        );

    } else if(componentOccurences > 1) {
        alert("Ce champ est déjà présent dans le formulaire");
        form.form.components.splice(
            index,
            1
        );
    }
}

/**
 *
 */
export function restyleFormButtons() {
    if ($('.formio-component-reset').length) {
        const resetBtnDiv = $('.formio-component-reset');
        resetBtnDiv.find('button').removeClass('btn-secondary').addClass('me-2 btn-outline-secondary');
        const submitBtnDiv = $('.formio-component-submit');
        $('.formio-form').append(
            $("<div class='d-flex justify-content-start flex-row-reverse flex-wrap'></div>").append(submitBtnDiv).append(resetBtnDiv)
        );
    }
}


export function disableComponentValidation(component) {
    if (component.hasOwnProperty("validate")) {
        component.validate.required = false;
        component.validate.pattern = "";
    }

    if (component.hasOwnProperty('fields')) {
        component.fields = Object.entries(component.fields).reduce((result, row) => {
            let key = row[0];
            let value = row[1];
            value.required = false;
            value.pattern = "";

            result[key] = value;
            return result;
        });
    }

    if (component.hasOwnProperty('components')) {
        FormioUtils.eachComponent(component.components, function(component, path) {
            disableComponentValidation(component)
        })
    }
}
